import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../../../context/ConfigContext";
import { Restaurant } from "../../../interfaces/Catalogue";
import { UserInfo } from "../../../interfaces/user";
import { getIcon, IconType } from "../../../theme/icons";
import CartMenu from "./CartMenu/CartMenu";
import "./TopBar.scss";
import UserMenu from "./UserMenu/UserMenu";
import RestaurantErrorModal from "../../shared/Modals/RestaurantErrorModal/RestaurantErrorModal";
import { getRestaurantStatusMessage } from "../../shared/ShiftInfo/ShiftInfo";

interface TopBarProps {
  restaurant?: Restaurant;
  showSwitchButton?: boolean;
  onSwitchPress?: () => void;
  onLogout?: () => void;
}

const TopBar: React.FC<TopBarProps> = ({
  restaurant,
  showSwitchButton = false,
  onSwitchPress,
  onLogout,
}) => {
  const navigate = useNavigate();
  const { config } = useConfig();
  const primaryColor = config?.primaryColor || "#6366F1";
  const userInfo: UserInfo = useSelector((state: any) => state.auth.userInfo);
  const token = localStorage.getItem("token");
  const accessToken = localStorage.getItem("accessToken");
  const [showRestaurantError, setShowRestaurantError] = useState(false);
  // Track screen size for conditional rendering
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < 1023);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleLoginClick = () => {
    navigate("/Authentification");
  };

  const handleFidelityClick = () => {
    navigate("/FIOFID");
  };

  return (
    <div className="auth-section">
      {!token && !accessToken ? (
        <button className="auth-login-btn" onClick={handleLoginClick}>
          Se connecter
        </button>
      ) : (
        <div className="auth-user-section">
          {/* Fidelity/Marketing Button */}
          <button
            className="auth-profile-btn"
            onClick={handleFidelityClick}
            style={{ color: primaryColor }}
          >
            {getIcon(IconType.Marketing, {
              color: config?.primaryColor,
              onClick: () => navigate("/FIOFID"),
            })}
          </button>

          {/* User Menu Component */}
          <UserMenu userInfo={userInfo} onLogout={onLogout} />
        </div>
      )}

      {restaurant?.id && restaurant?.hasReward && (
        <div className="fl_row">
          {getIcon(IconType.StarIconCircle, {
            color: config?.primaryColor,
            onClick: () => navigate(`/${restaurant?.id}/restaurant-fiofid`),
          })}
        </div>
      )}

      {/* Cart Menu Component */}
      <CartMenu setShowRestaurantError={setShowRestaurantError} />

      {/* Switch Restaurant Button */}
      {showSwitchButton && (
        <button
          className={`auth-login-btn ${isSmallScreen ? "switch-restaurant-btn" : ""}`}
          onClick={onSwitchPress}
          title={
            restaurant ? "Changer de restaurant" : "Sélectionner un restaurant"
          }
        >
          {isSmallScreen ? (
            <span className="switch-icon">
              <SwapHorizIcon style={{ fontSize: "18px" }} />
            </span>
          ) : (
            <span className="switch-text">
              {restaurant
                ? "Changer de restaurant"
                : "Sélectionner un restaurant"}
            </span>
          )}
        </button>
      )}
      <RestaurantErrorModal
        showRestaurantError={showRestaurantError}
        modalTitle="Restaurant Indisponible"
        modalDescription={getRestaurantStatusMessage(restaurant?.shifts || [])}
        modalButtonLabel="Retour au menu"
        onCloseModal={() => {
          setShowRestaurantError(false);
        }}
        onPressBtn={() => {
          setShowRestaurantError(false);
        }}
      />
    </div>
  );
};

export default TopBar;
